<div class="list-page">
  <app-asiakas-otsikko otsikko="Lisää asiakas" paluuUrl="/asiakkaat" [asiakas]="asiakas"></app-asiakas-otsikko>

  <form (ngSubmit)="save()" novalidate>
    <div style="max-width: 450px">
      <div class="light-blue-text" style="font-size: 18px; margin-bottom: 0px; line-height: 20px; margin-top: 55px">Yhteystiedot</div>
      <div style="margin-left: 10px; margin-right: 10px">
        <mat-form-field>
          <mat-label>{{ 'asiakas.nimi' | translate | async }}</mat-label>
          <input #nimiInput type="text" [formField]="lomake.nimi" matInput data-lpignore="true" />
          @if (naytaVirhe(lomake.nimi, 'required')) {
            <mat-error> Nimi puuttuu </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'Y-tunnus' }}</mat-label>
          <input type="text" [formField]="lomake.ytunnus" matInput data-lpignore="true" />
          @if (ytunnusVirhe) {
            <mat-hint><span class="lemon-error">Y-tunnus on virheellinen. Tämä ei estä tallentamista. Tarkista Y-tunnus</span></mat-hint>
          }
          @if (naytaVirhe(lomake.ytunnus, 'required')) {
            <mat-error> Y-tunnus puuttuu </mat-error>
          }
          @if (naytaVirhe(lomake.ytunnus, 'tupla')) {
            <mat-error> Y-tunnus on jo käytössä yrityksellä {{ ytunnusKaytossa().nimi }}. </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'lasku.katuosoite' | translate | async }}</mat-label>
          <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.katuosoite" matInput data-lpignore="true" />
          <!-- <mat-error *ngIf="katuosoite?.errors?.required && (katuosoite?.dirty || katuosoite?.touched)">
          {{ 'lasku.validation.katuosoite.required' | translate | async }}
        </mat-error> -->
        </mat-form-field>

        <div>
          <mat-form-field style="width: 48%; float: left">
            <mat-label>{{ 'lasku.postinro' | translate | async }}</mat-label>
            <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.postinro" matInput data-lpignore="true" />
            @if (naytaVirhe(lomake.postinro, 'required')) {
              <mat-error>
                {{ 'lasku.validation.postinro.required' | translate | async }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field style="width: 48%; float: right">
            <mat-label>{{ 'lasku.postitoimipaikka' | translate | async }}</mat-label>
            <input type="text" autocomplete="kirjanpitoaineistoarkki" [formField]="lomake.postitoimipaikka" matInput data-lpignore="true" />
            @if (naytaVirhe(lomake.postitoimipaikka, 'required')) {
              <mat-error>
                {{ 'lasku.validation.postitoimipaikka.required' | translate | async }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div style="clear: both; display: block"></div>

        <mat-form-field>
          <mat-label>{{ 'lasku.maa' | translate | async }}</mat-label>
          <mat-select [formField]="lomake.maa" style="width: 100%">
            @for (maa of suodatetutMaat | async; track maa) {
              <mat-option [value]="maa.koodi">
                {{ maa.nimi }}
              </mat-option>
            }
          </mat-select>
          @if (naytaVirhe(lomake.maa, 'required')) {
            <mat-error>
              {{ 'lasku.validation.maa.required' | translate | async }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="light-blue-text" style="font-size: 18px; margin-bottom: 0px; line-height: 20px; margin-top: 55px">Kirjanpito</div>
      <div style="margin-left: 10px; margin-right: 10px">
        <mat-form-field style="width: 48%; float: left">
          <mat-label>{{ 'Yritysmuoto' }}</mat-label>
          <mat-select [formField]="lomake.yritysmuoto">
            @for (yritysmuoto of yritysmuodot; track yritysmuoto) {
              <mat-option [value]="yritysmuoto.koodi">
                {{ yritysmuoto.nimi }}
              </mat-option>
            }
          </mat-select>
          @if (naytaVirhe(lomake.yritysmuoto, 'required')) {
            <mat-error> Yritysmuoto puuttuu </mat-error>
          }
        </mat-form-field>
        <mat-form-field style="width: 48%; float: right">
          <mat-label>{{ 'ALV-ilmoitusjakso' }}</mat-label>
          <mat-select [formField]="lomake.alvIlmoitusjakso">
            @for (jakso of alvIlmoitusjaksot; track jakso) {
              <mat-option [value]="jakso.koodi">
                {{ jakso.nimi }}
              </mat-option>
            }
          </mat-select>
          @if (naytaVirhe(lomake.alvIlmoitusjakso, 'required')) {
            <mat-error> ALV-ilmoitusjakso puuttuu </mat-error>
          }
        </mat-form-field>

        <div style="clear: both; display: block"></div>
        <div style="display: flex; justify-content: space-between">
          <!-- <mat-form-field style="max-width: 250px; margin-left: 0; margin-right: 10px;">
        <mat-label>{{ 'Tilikausi' }}</mat-label>
        <input type="text" formControlName="tilikausi"  matInput required data-lpignore="true" />
        <mat-error *ngIf="tilikausi?.errors?.required && (tilikausi?.dirty || tilikausi?.touched)">
          Kausi puuttuu
        </mat-error>
      </mat-form-field> -->
          <mat-form-field style="width: 48%; float: left">
            <!-- [min]="annaMinimiPaivamaara(hinta.get('voimassaAlkaen'))" -->
            <mat-label>Tilikausi alkaa</mat-label>
            <input type="text" [matDatepicker]="alkaaPicker" [formField]="lomake.tilikausiAlkaa" matInput data-lpignore="true" />
            <mat-datepicker-toggle matSuffix [for]="alkaaPicker"></mat-datepicker-toggle>
            @if (naytaVirhe(lomake.tilikausiAlkaa, 'required')) {
              <mat-error> Päivämäärä puuttuu </mat-error>
            }
            <mat-datepicker #alkaaPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field style="width: 48%; float: right">
            <!-- [min]="annaMinimiPaivamaara(hinta.get('voimassaAlkaen'))" -->
            <mat-label>Tilikausi loppuu</mat-label>
            <input type="text" [matDatepicker]="loppuuPicker" [formField]="lomake.tilikausiLoppuu" matInput data-lpignore="true" />
            <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle>
            @if (naytaVirhe(lomake.tilikausiLoppuu, 'required')) {
              <mat-error> Päivämäärä puuttuu </mat-error>
            }
            <mat-datepicker #loppuuPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div style="clear: both; display: block"></div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field>
            <mat-label>{{ 'laskuasetukset.iban' | translate | async }}</mat-label>
            <input type="text" [formField]="lomake.iban" matInput data-lpignore="true" />
            <mat-hint>{{ pankkiJaIbanTeksti() }}</mat-hint>
            @if (naytaVirhe(lomake.iban, 'required')) {
              <mat-error> IBAN puuttuu </mat-error>
            }
            @if (naytaVirhe(lomake.iban, 'iban')) {
              <mat-error> IBAN on virheellinen </mat-error>
            }
          </mat-form-field>
        </div>

        <div style="clear: both; display: block"></div>
        <div style="display: flex; justify-content: space-between">
          <mat-form-field>
            <mat-label>Kirjanpito-ohjelma</mat-label>
            <mat-select [value]="'lemonator'" required>
              <mat-option value="lemonator">Lemonator</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- <mat-form-field style="max-width: 250px; margin-left: 10px; margin-right: 10px;">
    <mat-label>{{ 'laskuasetukset.pankki' | translate | async }}</mat-label>
    <input type="text" formControlName="pankki"  matInput required data-lpignore="true" />
    <mat-error *ngIf="pankki?.errors?.required && (pankki?.dirty || pankki?.touched)">
      Pankki puuttuu
    </mat-error>
  </mat-form-field>
  <mat-form-field style="max-width: 250px; margin-left: 10px; margin-right: 0;">
    <mat-label>{{ 'laskuasetukset.bic' | translate | async }}</mat-label>
    <input type="text" formControlName="bic"  matInput required data-lpignore="true" />
    <mat-error *ngIf="bic?.errors?.required && (bic?.dirty || bic?.touched)">
      BIC puuttuu
    </mat-error>
    <mat-error *ngIf="bic?.errors?.bic && (bic?.dirty || bic?.touched)">
      BIC on virheellinen
    </mat-error>
  </mat-form-field> -->
      </div>

      <app-sopimusversio [lomake]="sopimusversioLomake" [hideVoimassaAlkaen]="true"></app-sopimusversio>

      <div class="light-blue-text" style="font-size: 18px; margin-bottom: 0px; line-height: 20px; margin-top: 55px">Laskutus</div>
      <div style="margin-left: 10px; margin-right: 10px">
        <!-- <div style="background-color: lightgray;">{{hinta?.errors | json}}</div> -->
        <mat-form-field style="width: 48%; float: left">
          <mat-label>Kuukausihinta</mat-label>
          <input decimalNumberField matInput [formField]="lomake.hinta" data-lpignore="true" />
          @if (naytaVirhe(lomake.hinta, 'required')) {
            <mat-error> Hinta puuttuu. </mat-error>
          }
          @if (naytaVirhe(lomake.hinta, 'min')) {
            <mat-error> Hinta on liian alhainen (vähintään 0,00). </mat-error>
          }
          @if (naytaVirhe(lomake.hinta, 'max')) {
            <mat-error> Hinta on liian suuri (enintään 2000,00). </mat-error>
          }
        </mat-form-field>

        <!-- <div style="background-color: lightgray;">{{voimassaAlkaen?.errors | json}}</div> -->
        <app-asiakas-lisaa-eka-lasku-kuukausi [minMonth]="minMonth" [kontrolli]="lomake.voimassaAlkaen" style="width: 48%; float: right"></app-asiakas-lisaa-eka-lasku-kuukausi>

        <div style="clear: both; display: block"></div>
        <mat-form-field>
          <mat-label>Kuukausihinnan perusteet</mat-label>
          <input type="text" [formField]="lomake.hinnanPerusteet" matInput data-lpignore="true" />
        </mat-form-field>

        <!-- <mat-form-field>
  <mat-label>Viitenumero</mat-label>
  <input type="text" [name]="inputname" formControlName="viitenumero" matInput data-lpignore="true" />
  <mat-hint>Viitenumero luodaan automaattisesti sen puuttuessa</mat-hint>
  <mat-error *ngIf="viitenumero?.errors?.required && (viitenumero?.dirty || viitenumero?.touched)">
    Viitenumero puuttuu
  </mat-error>
  <mat-error *ngIf="viitenumero?.errors?.viitenumero && (viitenumero?.dirty || viitenumero?.touched)">
    Viitenumero on virheellinen
  </mat-error>
</mat-form-field> -->

        <!-- <div class="light-blue-text" style="font-size: 18px; margin-bottom: 15px; line-height: 20px; margin-top: 20px;">Laskujen vastaanottajat</div> -->
        <div style="width: 100%; margin-top: 1em; min-height: 50px">
          <mat-chip-grid #vastaanottajaChips>
            @for (vastaanottaja of asiakas.laskunVastaanottajat; track vastaanottaja) {
              <mat-chip-option [selectable]="false" [removable]="true" (removed)="poistaLaskunVastaanottaja(vastaanottaja)">
                {{ vastaanottaja }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-option>
            }
          </mat-chip-grid>
        </div>
        <!-- {{lisaavastaanottaja?.errors | json}} -->
        <mat-form-field>
          <mat-label>{{ 'Lisää laskun vastaanottaja *' }}</mat-label>
          <input type="email" autocomplete="kirjanpitotietoarkki" [matChipInputFor]="vastaanottajaChips" (blur)="lisaaLaskunVastaanottaja()" [formField]="lomake.lisaavastaanottaja" (matChipInputTokenEnd)="lisaaLaskunVastaanottaja()" matInput data-lpignore="true" />
          <!-- <mat-icon matSuffix (click)="lisaa()">add</mat-icon> -->
          @if (naytaVirhe(lomake.lisaavastaanottaja, 'min')) {
            <mat-error> Lisää vähintään yksi vastaanottaja. </mat-error>
          }
          @if (naytaVirhe(lomake.lisaavastaanottaja, 'email')) {
            <mat-error> Sähköpostiosoite on virheellinen. </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="light-blue-text" style="font-size: 18px; margin-bottom: 0px; line-height: 20px; margin-top: 55px">Lisätiedot</div>
      <div style="margin-left: 10px; margin-right: 10px">
        <mat-form-field>
          <mat-label>Myyjä</mat-label>
          <mat-select [formField]="lomake.saleDoneBy" style="width: 100%">
            @for (sales of salesTeamOptions; track sales.avain) {
              <mat-option [value]="sales.avain">
                {{ sales.nimi }}
              </mat-option>
            }
          </mat-select>
          @if (naytaVirhe(lomake.saleDoneBy, 'required')) {
            <mat-error> Valitse myyjä </mat-error>
          }
        </mat-form-field>
        <app-asiakas-tagit [asiakas]="asiakas"></app-asiakas-tagit>
      </div>

      <div style="display: flex; justify-content: space-evenly; margin-top: 2em; margin-bottom: 2em">
        <!-- <button class="secondarybutton" mat-button routerLink="/asiakkaat" type="button">{{'yleiset.peruuta' | translate | async}}</button> -->
        <app-secondary-button (click)="save()" actionId="Tallenna uusi asiakas" [actionContext]="$any(lomake().value())">
          {{ 'yleiset.tallenna' | translate | async }}
        </app-secondary-button>
      </div>
    </div>
  </form>
</div>
